import React, { useEffect } from 'react';
import { observer, Observer } from 'mobx-react';
import { ThemeProvider } from 'styled-components';
import { useStores } from './hooks/use-stores';
import { awareGoTheme as theme } from './theme';

import './css/index.scss';
import {
    ThemeProvider as MuiThemeProvider,
    StyledEngineProvider,
} from '@mui/material/styles';
import Snackbar from './components/Snackbar';
import ConfirmationModal from './containers/ConfirmationModal';
import Waiting from './components/waiting';
import Header from './Header';
import Grid from '@material-ui/core/Grid';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import MainRoutes from './MainRoutes';
import { AwareGOTheme } from './theme-mui';

function AppShell() {
    const { commonStore, authStore } = useStores();
    const { appLoaded, messageShown } = commonStore;
    const { isAuthenticated, currentUser } = authStore;
    const location = useLocation();

    const date = new Date();

    const selectedNavSection = () => {
        const pathname = location.pathname.toLowerCase();
        if (pathname.startsWith('/companies')) return 1;
        else if (pathname.startsWith('/partners')) return 3;
        else if (pathname.startsWith('/freemium')) return 4;
        else if (pathname.startsWith('/subscriptions')) return 5;
        else if (pathname.startsWith('/languages')) return 6;
        else if (pathname.startsWith('/content')) return 7;
        else if (pathname.startsWith('/trainings')) return 8;
        else if (pathname.startsWith('/videos')) return 9;
        else if (pathname.startsWith('/notifications')) return 10;
        else if (pathname.startsWith('/admins')) return 15;
        else if (pathname.startsWith('/stats')) return 11;
        else if (pathname.startsWith('/gri')) return 14;
        else if (pathname.startsWith('/system')) return 12;
        else if (pathname.startsWith('/audit')) return 13;
        else if (pathname.startsWith('/webhook')) return 16;
        return 1;
    };
    const selectedSection = selectedNavSection();

    const getInitials = (name) => {
        if (!name) return '';
        return name.split(' ').map((n) => n[0]);
    };
    const currentUserInitials = currentUser ? getInitials(currentUser.name) : '';

    const loadApp = async () => {
        if (authStore.token) {
            try {
                await Promise.all([authStore.pullUser(), commonStore.loadLanguages()]);
            } finally {
                await commonStore.setAppLoaded();
            }
        } else {
            await commonStore.loadLanguages();
            await commonStore.setAppLoaded();
        }
    };
    const muiTheme = AwareGOTheme;

    useEffect(() => {
        loadApp();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const closeSnackbar = () => commonStore.hideMessage();
    const handleSignout = () => authStore.logout();

    return (
            <MuiThemeProvider theme={muiTheme}>
                <ThemeProvider theme={theme}>
                    <Observer>
                        {() =>
                            appLoaded ? (
                                <div className="layout_wrapper">
                                    <Helmet
                                        titleTemplate={'%s | Super AwareGO'}
                                        defaultTitle="Super AwareGO"
                                    />
                                    <Header
                                        isAuthenticated={isAuthenticated}
                                        currentUserInitials={currentUserInitials}
                                        currentUser={currentUser}
                                        selectedSection={selectedSection}
                                        handleSignout={handleSignout}
                                    />

                                    <main className="container_wrapper">
                                        <Grid
                                            container
                                            direction="row"
                                            justify="center"
                                            className="Container Flipped"
                                            spacing={2}
                                        >
                                            <Grid
                                                item
                                                xs={11}
                                                md={11}
                                                lg={11}
                                                xl={10}
                                                className="main_grid_wrapper Content"
                                            >
                                                {/* Внутри — ТВОЙ v6 MainRoutes без изменений */}
                                                <MainRoutes />
                                            </Grid>
                                        </Grid>
                                    </main>

                                    <footer className="app-footer">
                                        <a
                                            href="https://www.awarego.com/privacy"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Privacy Policy
                                        </a>
                                        &nbsp;&#183; © {date.getFullYear()} AwareGO
                                    </footer>

                                    <Snackbar
                                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                        autoHideDuration={6000}
                                        variant={commonStore.messageType}
                                        message={commonStore.message || ''}
                                        open={messageShown}
                                        onClose={closeSnackbar}
                                    />
                                    <ConfirmationModal />
                                </div>
                            ) : (
                                <Waiting waitingActive={!appLoaded} fullScreen={true} />
                            )
                        }
                    </Observer>
                </ThemeProvider>
            </MuiThemeProvider>
    );
}

export default observer(AppShell);
